import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  isRounded: boolean;
};

export const Container = styled.div<Props>(
  ({isRounded, theme}) => css`
    position: relative;
    height: 100%;
    outline-offset: 2px;

    ${isRounded &&
    css`
      border-radius: 5px;
      overflow: hidden;
    `}

    &:focus-visible {
      outline: none;

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        border: ${theme.colors.focusState} dashed 2px;
        border-radius: ${isRounded ? '5px' : '0'};
        pointer-events: none;
        z-index: 1;
      }
    }
  `
);
